import { Directive, inject, OnInit } from '@angular/core';
import { SettingsService } from '../shared/settings/settings.service';
import { RouterLink } from '@angular/router';

@Directive({
  selector: '[lfwShouldOpenInNewTab]',
  standalone: true
})
export class OpenInNewTabDirective implements OnInit {
  settingsService = inject(SettingsService);

  private readonly _routerLinkDirective = inject(RouterLink);

  ngOnInit() {
    if (this.settingsService.settings.orderSettings.openOrderInNewTab) {
      this._routerLinkDirective.target = '_blank';
    }
  }
}
